import { FunctionComponent } from "react";

import { Icon, IconProps } from "./icon";

export const AddCircle: FunctionComponent<IconProps> = ({ className }) => {
    return (
        <Icon className={className}>
            <path d="M8.75 4.25a.75.75 0 0 0-1.5 0v3h-3a.75.75 0 0 0 0 1.5h3v3a.75.75 0 0 0 1.5 0v-3h3a.75.75 0 0 0 0-1.5h-3v-3Z"></path>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 8a8 8 0 0 1-8 8 8 8 0 0 1-8-8 8 8 0 0 1 8-8c4.43 0 8 3.581 8 8Zm-1.5 0A6.5 6.5 0 0 1 8 14.5 6.5 6.5 0 0 1 1.5 8 6.5 6.5 0 0 1 8 1.5c3.6 0 6.5 2.908 6.5 6.5Z"
            ></path>
        </Icon>
    );
};
